/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateOrderInfoRequest
 */
export interface UpdateOrderInfoRequest {
    /**
     * 乗客名 (姓名合計90文字以内)
     * @type {string}
     * @memberof UpdateOrderInfoRequest
     */
    passengerFirstName?: string;
    /**
     * 乗客姓 (姓名合計90文字以内)
     * @type {string}
     * @memberof UpdateOrderInfoRequest
     */
    passengerLastName?: string;
    /**
     * 電話番号（ハイフン含む・最大15文字）
     * @type {string}
     * @memberof UpdateOrderInfoRequest
     */
    passengerPhoneNumber?: string;
    /**
     * 電話番号国コード
     * @type {string}
     * @memberof UpdateOrderInfoRequest
     */
    passengerPhoneCountryCode?: string;
    /**
     * 実際の運賃（単位：円）
     * @type {number}
     * @memberof UpdateOrderInfoRequest
     */
    actualFare?: number;
    /**
     * 有料道路料金（単位：円）
     * @type {number}
     * @memberof UpdateOrderInfoRequest
     */
    tollroadFee?: number;
    /**
     * 希望支払方法
     * @type {string}
     * @memberof UpdateOrderInfoRequest
     */
    desiredPaymentMethod?: string;
    /**
     * 実績支払方法
     * @type {string}
     * @memberof UpdateOrderInfoRequest
     */
    actualPaymentMethod?: string;
    /**
     * 配車状態（1:配車中（未応答）, 2:探車失敗, 3:迎車中（現着前）, 4:迎車中（現着済）, 5:実車中, 6:代車要請中, 7:支払完了, 8:支払中（決済失敗）, 9:実車中, 11:利用者キャンセル, 12:事業者キャンセル, 13:QR連携キャンセル）
     * @type {string}
     * @memberof UpdateOrderInfoRequest
     */
    carDispatchStatus?: string;
    /**
     * 料金種別 (1:メータ運賃, 2:事前確定, 3:事前確定運賃（RS含む）)
     * @type {string}
     * @memberof UpdateOrderInfoRequest
     */
    fareType?: string;
}

/**
 * Check if a given object implements the UpdateOrderInfoRequest interface.
 */
export function instanceOfUpdateOrderInfoRequest(value: object): value is UpdateOrderInfoRequest {
    return true;
}

export function UpdateOrderInfoRequestFromJSON(json: any): UpdateOrderInfoRequest {
    return UpdateOrderInfoRequestFromJSONTyped(json, false);
}

export function UpdateOrderInfoRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateOrderInfoRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'passengerFirstName': json['passenger_first_name'] == null ? undefined : json['passenger_first_name'],
        'passengerLastName': json['passenger_last_name'] == null ? undefined : json['passenger_last_name'],
        'passengerPhoneNumber': json['passenger_phone_number'] == null ? undefined : json['passenger_phone_number'],
        'passengerPhoneCountryCode': json['passenger_phone_country_code'] == null ? undefined : json['passenger_phone_country_code'],
        'actualFare': json['actual_fare'] == null ? undefined : json['actual_fare'],
        'tollroadFee': json['tollroad_fee'] == null ? undefined : json['tollroad_fee'],
        'desiredPaymentMethod': json['desired_payment_method'] == null ? undefined : json['desired_payment_method'],
        'actualPaymentMethod': json['actual_payment_method'] == null ? undefined : json['actual_payment_method'],
        'carDispatchStatus': json['car_dispatch_status'] == null ? undefined : json['car_dispatch_status'],
        'fareType': json['fare_type'] == null ? undefined : json['fare_type'],
    };
}

export function UpdateOrderInfoRequestToJSON(json: any): UpdateOrderInfoRequest {
    return UpdateOrderInfoRequestToJSONTyped(json, false);
}

export function UpdateOrderInfoRequestToJSONTyped(value?: UpdateOrderInfoRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'passenger_first_name': value['passengerFirstName'],
        'passenger_last_name': value['passengerLastName'],
        'passenger_phone_number': value['passengerPhoneNumber'],
        'passenger_phone_country_code': value['passengerPhoneCountryCode'],
        'actual_fare': value['actualFare'],
        'tollroad_fee': value['tollroadFee'],
        'desired_payment_method': value['desiredPaymentMethod'],
        'actual_payment_method': value['actualPaymentMethod'],
        'car_dispatch_status': value['carDispatchStatus'],
        'fare_type': value['fareType'],
    };
}

